import { pickBy } from "lodash";
import { DateTime } from "luxon";

import { Filters, JsonValue, Pager, Sort } from "./types";

/**
 * @see Use forgeFiltersParams instead
 */
export const pagerWriter = (pager: Pager): JsonValue => {
  if (!pager) return {};
  else
    return {
      ...(pager.page && { page: pager.page }),
      ...(pager.size !== undefined && { size: pager.size }),
    };
};

/**
 * @see Use forgeFiltersParams instead
 */
export const sortWriter = (sort: Sort): JsonValue => {
  if (!sort) return {};
  else
    return {
      ...(sort.field && sort.order && { sort: `${sort.order === "asc" ? " " : "-"}${sort.field}` }),
    };
};

/**
 * @see Use forgeFiltersParams instead
 */
export const filterWriter = (filters: Filters): JsonValue => removeUndefined(filters) || {};

export const forgeFiltersParams = (params: {
  filters?: Filters;
  pager?: Pager;
  sort?: Sort;
}): Record<string, string> => {
  return {
    ...(params.filters ? filterWriter(params.filters) : {}),
    ...(params.pager ? pagerWriter(params.pager) : {}),
    ...(params.sort ? sortWriter(params.sort) : {}),
  };
};

export const formatDate = (
  data: DateTime | null | undefined,
  format: string = "yyyy-LL-dd"
): string | null | undefined => (data ? data.toFormat(format) : data);

export const removeUndefined = (data: JsonValue): JsonValue =>
  pickBy(data, value => value !== undefined);
